// @ts-check
import React, { useCallback } from 'react';
import PropertiesConditionEditorModal from 'components/Condition/PropertiesCondition/PropertiesConditionEditorModal';
import { Button } from '@patternfly/react-core';
import useBoolean from 'utils/hooks/useBoolean';
import { useTranslation } from 'localization/useTranslation';
/**
 * @typedef {import('./PropertiesConditionEditor').Condition} Condition
 */

/**
 * @typedef {object} PropertyConditionButtonProps
 * @property {string} title
 * @property {Condition[]} conditions
 * @property {(newConditions: Condition[]) => void} onConditionsChanged
 */

/**
 * @param {PropertyConditionButtonProps} props
 * @returns
 */
const PropertyConditionButton = ({ title, conditions, onConditionsChanged }) => {
  const T = useTranslation();
  const [isModalOpen, showModal, hideModal] = useBoolean(false);
  const _onConditionsChanged = useCallback((newConditions) => {
    onConditionsChanged(newConditions);
    hideModal();
  }, [onConditionsChanged, hideModal]);
  const countOptions = {
    isRead: false,
    count: conditions?.length ?? 0
  };

  return (<>
    <Button onClick={showModal} countOptions={countOptions}>{ T.localize(title) }</Button>
    <PropertiesConditionEditorModal
      conditions={conditions}
      title={title}
      isOpen={isModalOpen}
      onConfirm={_onConditionsChanged}
      onCancel={hideModal} />
  </>);
};

export default React.memo(PropertyConditionButton);

